// This icon file is generated automatically.
var PMessageOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 16 16", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7.14 8a.86.86 0 101.72 0 .86.86 0 00-1.72 0zm3.57 0a.86.86 0 101.72 0 .86.86 0 00-1.72 0zM3.57 8A.86.86 0 105.3 8a.86.86 0 00-1.72 0zm11.8-3.1A8 8 0 008 0h-.04a7.98 7.98 0 00-7.1 11.6v2.72c0 .45.36.82.82.82h2.71c1.1.56 2.33.85 3.57.86H8a8 8 0 007.38-11.1zm-2.69 7.82A6.6 6.6 0 018 14.64h-.03a6.67 6.67 0 01-3.1-.77l-.14-.08H2.2v-2.52l-.08-.15a6.67 6.67 0 011.15-7.8 6.6 6.6 0 014.7-1.96H8a6.61 6.61 0 016.65 6.67 6.62 6.62 0 01-1.97 4.7z", "fill-rule": "nonzero" } }] }, "name": "p-message", "theme": "outlined" };
export default PMessageOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PMessageOutlined.js
// module id = 3511
// module chunks = 0